import * as e from "react";
import n from "../lib/IconBase.es.js";
import c from "../defs/SortDescending.es.js";
const o = e.forwardRef((r, t) => /* @__PURE__ */ e.createElement(n, { ref: t, ...r, weights: c }));
o.displayName = "SortDescendingIcon";
const i = o;
export {
  i as SortDescending,
  o as SortDescendingIcon
};
